import React, { Component, Fragment } from "react";
import { Form } from "react-bootstrap";
import { Dropdown } from "semantic-ui-react";
import AlertBasic from "../alerts/AlertBasic";

class QuestionTypes extends Component {
    state = {
        questionTypeList: [],
        selectedSubtestType: this.props.subtestType ? this.props.subtestType : null,
        value: this.props.defaultValue ? this.props.defaultValue : null,
    };

    getQuestionTypes = async () => {
        const { fetchURL, defaultValue } = this.props;
        const { selectedSubtestType } = this.state;
        try {
            const response = await fetch(`${fetchURL}/question-types`, {
                credentials: "include", //include - bez tego nie będą pojawiać się ciasteczka w przeglądarce
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
            });
            if (response.status === 200) {
                await response.json().then((fetchedData) => {
                    if (fetchedData.status === true) {
                        let questionTypeList = fetchedData.questionTypeList;
                        if (defaultValue === "all") {
                            questionTypeList.unshift({
                                key: 0,
                                value: "all",
                                text: "Wszystkie",
                            });
                        }

                        //jeśli elementy dropdownu muszą zostać wyfiltrowane o wybraną część testu (dla testu PJM są filmiki i obrazki, dla PL są słowa i obrazki)
                        if (selectedSubtestType) {
                            questionTypeList = questionTypeList.filter(
                                (e) => (selectedSubtestType === "PJM" && (e.value === "V4I" || e.value === "I4V" || e.value === "V4V")) || (selectedSubtestType === "PL" && (e.value === "W4I" || e.value === "I4W" || e.value === "W4W"))
                            );
                        }

                        this.setState({ questionTypeList: questionTypeList });
                    } else if (fetchedData.status === false) {
                        this.setState({ alert: { variant: "danger", message: fetchedData.message } });
                    }
                });
            } else {
                this.setState({ alert: { variant: "danger", message: response.status } });
            }
        } catch (err) {
            this.setState({ loading: false, alert: { variant: "danger", message: "Błąd połączenia z serwerem. Spróbuję pobrać/wysłać dane jeszcze raz." } });
            setTimeout(this.getQuestionTypes(), 4000);
        }
    };

    componentDidMount() {
        this.getQuestionTypes();
    }

    componentDidUpdate() {
        if (this.props.defaultValue !== this.state.value) this.setState({ value: this.props.defaultValue });
        if (this.props.subtestType)
            if (this.props.subtestType !== this.state.selectedSubtestType) {
                this.setState({ selectedSubtestType: this.props.subtestType, value: null }, () => this.getQuestionTypes());
            }
    }

    render() {
        const { questionTypeList, alert, value } = this.state;
        const { onQuestionTypeSelected, req } = this.props;
        return (
            <Fragment>
                {alert && <AlertBasic variant={alert.variant} mssg={alert.message} onCloseAlert={() => this.setState({ alert: "" })} fading={alert.fading} />}

                <Form.Group>
                    <Form.Label>Typ pytania {req && <span className="required">*</span>}</Form.Label>

                    <Dropdown
                        id="questionTypesDropdown"
                        className={req ? "form-dropdown mb-3 req" : "form-dropdown mb-3"}
                        placeholder="Wszystkie"
                        fluid
                        value={value}
                        selection
                        options={questionTypeList}
                        onChange={(event, { value }) => {
                            onQuestionTypeSelected(event, value);
                            this.setState({ value: value });
                        }}
                    />
                </Form.Group>
            </Fragment>
        );
    }
}

export default QuestionTypes;
